'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseStyles = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  body {\n    color: rgb(68, 68, 68);\n    font-family: -apple-system, ".SFNSText-Regular", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", "Lucida Grande", sans-serif;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .Resizer {\n    background: transparent;\n\n    &:after {\n      background: transparent;\n      content: \' \';\n      display: block;\n      position: absolute;\n    }\n\n    &.horizontal {\n      cursor: row-resize;\n      padding-top: 3px;\n      height: 10px;\n\n      &:after {\n        border-top: 1px solid rgba(0, 0, 0, .2);\n        border-bottom: 1px solid rgba(0, 0, 0, .2);\n        left: calc(50% - 20px);\n        height: 2px;\n        width: 20px;\n      }\n    }\n\n    &.vertical {\n      cursor: col-resize;\n      padding-left: 3px;\n      width: 10px;\n\n      &:after {\n        border-left: 1px solid rgba(0, 0, 0, .2);\n        border-right: 1px solid rgba(0, 0, 0, .2);\n        top: calc(50% - 20px);\n        height: 20px;\n        width: 2px;\n      }\n    }\n\n    &.disabled {\n      cursor: not-allowed;\n\n      &:hover {\n        border-color: transparent;\n      }\n    }\n  }\n\n  ', '\n'], ['\n  body {\n    color: rgb(68, 68, 68);\n    font-family: -apple-system, ".SFNSText-Regular", "San Francisco", Roboto, "Segoe UI", "Helvetica Neue", "Lucida Grande", sans-serif;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .Resizer {\n    background: transparent;\n\n    &:after {\n      background: transparent;\n      content: \' \';\n      display: block;\n      position: absolute;\n    }\n\n    &.horizontal {\n      cursor: row-resize;\n      padding-top: 3px;\n      height: 10px;\n\n      &:after {\n        border-top: 1px solid rgba(0, 0, 0, .2);\n        border-bottom: 1px solid rgba(0, 0, 0, .2);\n        left: calc(50% - 20px);\n        height: 2px;\n        width: 20px;\n      }\n    }\n\n    &.vertical {\n      cursor: col-resize;\n      padding-left: 3px;\n      width: 10px;\n\n      &:after {\n        border-left: 1px solid rgba(0, 0, 0, .2);\n        border-right: 1px solid rgba(0, 0, 0, .2);\n        top: calc(50% - 20px);\n        height: 20px;\n        width: 2px;\n      }\n    }\n\n    &.disabled {\n      cursor: not-allowed;\n\n      &:hover {\n        border-color: transparent;\n      }\n    }\n  }\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: rgb(247, 247, 247);\n  display: flex;\n  height: 100vh;\n'], ['\n  background-color: rgb(247, 247, 247);\n  display: flex;\n  height: 100vh;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border: solid 1px #E4E4E4;\n  border-radius: 5px;\n  margin: 10px 10px 0 0;\n  height: calc(100% - 10px);\n  overflow: scroll;\n'], ['\n  background-color: #fff;\n  border: solid 1px #E4E4E4;\n  border-radius: 5px;\n  margin: 10px 10px 0 0;\n  height: calc(100% - 10px);\n  overflow: scroll;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledNormalize = require('styled-normalize');

var _styledNormalize2 = _interopRequireDefault(_styledNormalize);

var _reactSplitPane = require('react-split-pane');

var _reactSplitPane2 = _interopRequireDefault(_reactSplitPane);

var _sidebar = require('./sidebar');

var _sidebar2 = _interopRequireDefault(_sidebar);

var _actionLogger = require('./action-logger');

var _actionLogger2 = _interopRequireDefault(_actionLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// global css to load on devNovel.injectUI()
var baseStyles = exports.baseStyles = function baseStyles() {
  return (0, _styledComponents.injectGlobal)(_templateObject, _styledNormalize2.default);
};

var UIWrapper = _styledComponents2.default.div(_templateObject2);

var StoryContainer = _styledComponents2.default.div(_templateObject3);

var paneStyle = {
  overflow: 'scroll'
};

var DevNovelUI = function DevNovelUI(_ref) {
  var devNovelInstance = _ref.devNovelInstance;
  return _react2.default.createElement(
    UIWrapper,
    null,
    _react2.default.createElement(
      _reactSplitPane2.default,
      { split: 'vertical', minSize: 250 },
      _react2.default.createElement(_sidebar2.default, { devNovelInstance: devNovelInstance }),
      _react2.default.createElement(
        _reactSplitPane2.default,
        { split: 'horizontal', defaultSize: 200, primary: 'second', paneStyle: paneStyle },
        _react2.default.createElement(StoryContainer, { id: 'story-container' }),
        _react2.default.createElement(_actionLogger2.default, { devNovelInstance: devNovelInstance })
      )
    )
  );
};

exports.default = DevNovelUI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dev-novel/dist/ui/index.js
// module id = 330
// module chunks = 0